import { useEffect, useState } from "react";
import { Rocket, X } from "lucide-react";

const LAUNCH = new Date("2026-09-11T04:00:00+10:00"); // WARDOGS Early Access — 4:00 AM AEST, Sep 11

const LaunchCountdown = () => {
  const [now, setNow] = useState(Date.now());
  const [hidden, setHidden] = useState(() => localStorage.getItem("wardogs_launch_dismissed") === "1");

  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);

  const diff = LAUNCH.getTime() - now;
  if (hidden || diff <= 0) return null;

  const d = Math.floor(diff / 86400000);
  const h = Math.floor((diff % 86400000) / 3600000);
  const m = Math.floor((diff % 3600000) / 60000);
  const s = Math.floor((diff % 60000) / 1000);

  return (
    <div data-testid="launch-countdown" className="relative bg-gradient-to-r from-[#1a1206] via-[#13151B] to-[#1a1206] border-b border-[#D4A94A]/30 px-4 py-2.5">
      <div className="max-w-[1600px] mx-auto flex items-center justify-center gap-3 flex-wrap text-center">
        <Rocket className="w-4 h-4 text-[#D4A94A] shrink-0" />
        <span className="font-stencil font-bold uppercase text-xs sm:text-sm text-[#F1F5F9] tracking-wide">WARDOGS Early Access launches in</span>
        <span className="font-heading font-black text-sm sm:text-base tabular-nums text-[#D4A94A]" data-testid="launch-countdown-timer">
          {d}d {String(h).padStart(2, "0")}h {String(m).padStart(2, "0")}m {String(s).padStart(2, "0")}s
        </span>
      </div>
      <button
        data-testid="launch-countdown-close"
        onClick={() => { localStorage.setItem("wardogs_launch_dismissed", "1"); setHidden(true); }}
        aria-label="Dismiss"
        className="absolute right-3 top-1/2 -translate-y-1/2 text-[#64748B] hover:text-[#F1F5F9]"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};

export default LaunchCountdown;
